import React from 'react';
import MyIntroduction from './MyIntroduction';
import MySkill from './MySkill';
import MyExp from './MyExp';
import MyRemu from './MyRemu';
import MyQual from './MyQualification';
import MyAccomplishments from './MyAccomplishments';
import MyReferences from './MyReferences';
import MyExtracurriculars from './MyExtracurriculars';
import MyPersonalInfo from './MyPersonalInfo';
import MyContact from './MyContact';

function CreateProfile(props) {
    var { store } = props
    console.log("store", store)
    return (
        <div className="page-wrapper">          
            <MyIntroduction  store={store}/>
            <MySkill  store={store}/>
            <MyExp store={store}/>
            <MyRemu store={store}/>
            <MyQual store={store}/>
            <MyAccomplishments store={store}/>
            <MyReferences store={store}/>
            <MyExtracurriculars store={store}/>
            <MyPersonalInfo store={store}/>
            <MyContact store={store}/>            
        </div>
    
    );
  }

export default CreateProfile